// App shell (DESIGN_SPEC §10.1), the root route element:
//   skip link · atmosphere (Submit and full-page states) · nav · banner · <main id="main"><Outlet/></main>
//   · footer · scroll restoration
// Each route's default document.title comes from its handle and is set before the page's own
// effects run, so a page title always wins.
//   <Layout />
import { useEffect } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { Atmosphere } from "./Atmosphere";
import { Banner } from "./Banner";
import { Footer } from "./Footer";
import { Nav } from "./Nav";
import { useRouteHandle } from "./routeHandle";

function RouteTitle({ routeId, title }: { routeId?: string; title?: string }) {
  useEffect(() => {
    if (title) document.title = title;
  }, [routeId, title]);
  return null;
}

export function Layout() {
  const { id, title, atmosphere } = useRouteHandle();

  return (
    // a column at least one viewport tall, so the footer sits at the bottom of short pages
    <div className="flex min-h-dvh flex-col">
      <RouteTitle routeId={id} title={title} />
      <a className="skip" href="#main">
        Skip to content
      </a>
      {atmosphere && <Atmosphere />}
      <Nav />
      <Banner />
      {/* at least a viewport under the nav: the footer never paints mid-screen while a page loads, then jumps */}
      <main id="main" tabIndex={-1} className="min-h-[calc(100dvh-var(--nav-h))] flex-1 focus-visible:outline-none">
        <Outlet />
      </main>
      <Footer flat={atmosphere === "hero"} />
      <ScrollRestoration />
    </div>
  );
}
